// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","page":"IndexPage__page--Y9","pipelineList":"IndexPage__pipelineList--iZ"};